  (function () {
  /* console.log */
  var DEBUG = false;
  function log(){ if(DEBUG) try{ console.log.apply(console, arguments); }catch(e){} }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getVariantFromURL() {
    var params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  function findVariantInput(scope) {
    return (
      scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      scope.querySelector('input[name="id"]')
    );
  }

  function initOne(root) {
    // ID listesi
    var allowedRaw = (root.getAttribute("data-variant-ids") || "").replace(/\s/g, "");
    var allowed = allowedRaw ? allowedRaw.split(",") : [];
    if (!allowed.length) {
      log("No allowed variant ids on", root);
    }

    function setVisibility(variantId) {
      if (!variantId) return;
      var show = allowed.indexOf(String(variantId)) > -1;
      root.style.display = show ? "block" : "none";
      log("setVisibility", { variantId: String(variantId), show: show });
    }


    var scope = root.closest('section, .product, .product-section') || document;


    var idInput = findVariantInput(scope);
    var initialVid = (idInput && idInput.value) || getVariantFromURL();
    if (initialVid) setVisibility(initialVid);

    /* Tema Eventleri */
    var evtNames = [
      "variant:changed",   
      "variant:change",          
      "product:variant-change",   
      "theme:variant:change"      
    ];
    evtNames.forEach(function (n) {
      document.addEventListener(n, function (e) {
        var v = e && e.detail;
        var vid = v && (v.id || (v.variant && v.variant.id));
        if (!vid && typeof v === "object") {
          if ("variantId" in v) vid = v.variantId;
          if ("currentVariantId" in v) vid = v.currentVariantId;
        }
        if (vid) setVisibility(vid);
      });
    });

    if (idInput) {
      idInput.addEventListener("change", function (e) {
        setVisibility(e.target.value);
      });

      var prevVal = idInput.value;
      var obs = new MutationObserver(function () {
        if (idInput.value !== prevVal) {
          prevVal = idInput.value;
          setVisibility(prevVal);
        }
      });
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }

    window.addEventListener("popstate", function () {
      var vid = getVariantFromURL();
      if (vid) setVisibility(vid);
    });
  }

  ready(function () {
    // Bir sayfada birden çok marquee olabilir
    var roots = document.querySelectorAll('[id^="marquee-"].izdk-marquee-wrapper, .izdk-marquee-wrapper[id^="marquee-"]');
    if (!roots.length) {
      log("No marquee roots found");
      return;
    }
    roots.forEach(initOne);
  });
})();